import React, { useState, useEffect, useRef } from 'react'
import {
    I2cButton,
    I2cIcon,
    I2cTooltip,
    I2cRadioGroup,
    I2cRadioButton,
    I2cFileUpload,
    I2cTextarea,
    I2cInput, I2cColorPicker, I2cDataTable
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import { getValidationSchemaMobile } from "./ValidationSchema";
import { customMenus } from "./stringUtils";
import { useMutation } from "react-query";
import { CheckboxRenderer, InputRenderer, IconRenderer } from './CellRenderer';
import FilesUploadService from "../../../Services/FilesUploadService";
import AndroidGuidelines from "./MobileAppModules/AndroidGuidelines";
import IOSApplicationGuidelines from "./MobileAppModules/IOSApplicationGuidelines"

const MobileAppGraphicsSpecifications = ({
    type,
    setAddFormData,
    addFormData,
    setFormValidStates,
    formDataJson,
    isFetching,
}) => {

    const table = useRef();
    const fileRefs = useRef({});
    const [rowDataInitial, setRowDataInitial] = useState(customMenus || []);
    const [gridOptions, setGridOptions] = useState({});
    const [isFormDataUpdated, setIsFormDataUpdated] = useState(false);
    const [nav, setNav] = useState(0);
    const [navigationMob, setNavigationMob] = useState([
        "App Icon", "Splash Screen", "Introduction", "Login", "Public Menus & Icons"]);
    const sectionsRef = useRef([]);
    const handleNav = (active) => {
        setNav(active);
        sectionsRef.current[active].scrollIntoView({ behavior: 'smooth' });
    }
    const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
    const validationSchemaMob = getValidationSchemaMobile(appSelectionForProgram);
    const bothApps = appSelectionForProgram.includes("iOS App") && appSelectionForProgram.includes("Android App");
    const androidApp = appSelectionForProgram.includes("Android App");
    const iosApp = appSelectionForProgram.includes("iOS App");
    useEffect(() => {
        if (bothApps) {
            setNavigationMob([
                "App Icon", "Splash Screen", "Introduction", "Login", "Public Menus & Icons", "iOS Guidelines", "Android Guidelines"
            ]);
        } else if (androidApp && !iosApp) {
            setNavigationMob([
                "App Icon", "Splash Screen", "Introduction", "Login", "Public Menus & Icons", "Android Guidelines"
            ]);
        } else if (iosApp && !androidApp) {
            setNavigationMob([
                "App Icon", "Splash Screen", "Introduction", "Login", "Public Menus & Icons", "iOS Guidelines"
            ]);
        }
    }, [appSelectionForProgram]);
    const [colorNav, setColorNav] = useState("#ffffff");
    const [fileJson, setFileJson] = useState([]);
    const [colorSchemeLogin, setColorSchemeLogin] = useState({});;

    const [colorValues, setColorValues] = useState({});
    const getFileRef = (fieldName) => {
        if (!fileRefs.current[fieldName]) {
            fileRefs.current[fieldName] = React.createRef();
        }
        return fileRefs.current[fieldName];
    };
    const state = type === "credit" ? "2_3" : "3_3"

    // Initialize React Hook Form with Yup resolver
    const methods = useForm({
        resolver: yupResolver(validationSchemaMob),
        mode: "all",
        reValidateMode: "all",
        shouldUseNativeValidation: false,
        criteriaMode: "all",
        defaultValues: {
            brand_info_mob_app_icon_file: "",
            brand_info_mob_app_splash_screen_file: "",
            brand_info_mob_app_card_design_file: "",
            brand_info_mob_app_textual_content: "",
            brand_info_mob_app_art_background_image_file: "",
            brand_info_mob_app_additional_textual_content_file: "",
            brand_info_mob_app_sign_up_option: "Yes",
            brand_info_mob_app_nav_color_scheme: "Default color scheme",
            brand_info_mob_app_nav_color_scheme_field: "",
            brand_info_mob_app_nav_color_scheme_logo: "",
            brand_info_mob_app_login_color_scheme_code: [''],
            brand_info_mob_app_login_background_file: "",
            brand_info_mob_app_public_menus_icons_type: "Default Menus & Icons",
            brand_info_mob_app_public_menus_custom: [],
            brand_info_mob_app_ios_icon_file: "",
            brand_info_mob_app_ios_app_name: "",
            brand_info_mob_app_ios_description_for_app_store: "",
            brand_info_mob_app_ios_keywords: "",
            brand_info_mob_app_ios_support_url: "",
            brand_info_mob_app_ios_module_features_file: [],
            brand_info_mob_app_android_icon_file: "",
            brand_info_mob_app_android_app_name: "",
            brand_info_mob_app_android_description_for_app_store: "",
            brand_info_mob_app_android_keywords: "",
            brand_info_mob_app_android_support_url: "",
            brand_info_mob_app_android_module_features_file: [],
        },
    });
    const fields = [
        "brand_info_mob_app_icon_file",
        "brand_info_mob_app_splash_screen_file",
        "brand_info_mob_app_card_design_file",
        "brand_info_mob_app_textual_content",
        "brand_info_mob_app_art_background_image_file",
        "brand_info_mob_app_additional_textual_content_file",
        "brand_info_mob_app_sign_up_option",
        "brand_info_mob_app_nav_color_scheme",
        "brand_info_mob_app_nav_color_scheme_field",
        "brand_info_mob_app_nav_color_scheme_logo",
        "brand_info_mob_app_login_background_file",
        "brand_info_mob_app_public_menus_icons_type",
        "brand_info_mob_app_ios_icon_file",
        "brand_info_mob_app_ios_app_name",
        "brand_info_mob_app_ios_description_for_app_store",
        "brand_info_mob_app_ios_keywords",
        "brand_info_mob_app_ios_support_url",
        "brand_info_mob_app_android_icon_file",
        "brand_info_mob_app_android_app_name",
        "brand_info_mob_app_android_description_for_app_store",
        "brand_info_mob_app_android_keywords",
        "brand_info_mob_app_android_support_url",

    ];
    const fieldsArray = [
        "brand_info_mob_app_login_color_scheme_code",
        "brand_info_mob_app_android_module_features_file",
        "brand_info_mob_app_ios_module_features_file",
    ];

    // Controlls destructuring from the method
    const {
        control,
        formState: { errors },
    } = methods;
    const { fields: fieldColor, append } = useFieldArray({
        control,
        name: "brand_info_mob_app_login_color_scheme_code",
    });

    const addColorField = () => {
        append('');
    };
    const handleColorChange = (index, value) => {
        setColorValues((prev) => ({ ...prev, [index]: value }));
        handleValueChanges();
    };
    useEffect(() => {
        if (!isFetching && Object.keys(formDataJson ?? {}).length) {
            if (type === "credit") {
                fields.forEach((field) => {
                    methods.setValue(field, formDataJson[2]["2_3"][field] ?? "");
                });
                fieldsArray.forEach((field) => {
                    methods.setValue(field, formDataJson[2]["2_3"][field] ?? []);
                });
                setFileJson(formDataJson[2]["2_3"]);

            }
            else {
                fields.forEach((field) => {
                    methods.setValue(field, formDataJson[3]["3_3"][field] ?? "");
                });
                fieldsArray.forEach((field) => {
                    methods.setValue(field, formDataJson[3]["3_3"][field] ?? []);
                });
                setFileJson(formDataJson[3]["3_3"]);
            }
            methods.trigger();
            handleValueChanges();
            setIsFormDataUpdated(true)
        }
    }, [isFetching]);
    useEffect(() => {
        if (!iosApp) {
            methods.setValue("brand_info_mob_app_ios_icon_file", null);
            methods.setValue("brand_info_mob_app_ios_app_name", "");
            methods.setValue("brand_info_mob_app_ios_description_for_app_store", "");
            methods.setValue("brand_info_mob_app_ios_keywords", "");
            methods.setValue("brand_info_mob_app_ios_support_url", "");
            methods.setValue("brand_info_mob_app_ios_module_features_file", []);
        }
        if (!androidApp) {
            methods.setValue("brand_info_mob_app_android_icon_file", null);
            methods.setValue("brand_info_mob_app_android_app_name", "");
            methods.setValue("brand_info_mob_app_android_description_for_app_store", "");
            methods.setValue("brand_info_mob_app_android_keywords", "");
            methods.setValue("brand_info_mob_app_android_support_url", "");
            methods.setValue("brand_info_mob_app_android_module_features_file", []);
        }
        methods.trigger();
        handleValueChanges();
    }, [appSelectionForProgram]);
    
    const handleGridApi = async (data) => {
        try {
            const gridApi = await table?.current.getGridApi();
            gridApi.updateGridOptions({ rowData: data });
        } catch (error) {
            console.warn('Error getting grid API:', error);
        }
    };
    const addNewRow = (table) => {
        const newRow = {
            feature: 'Click to edit',
            alternativeMethod: '',
            enabled: false,
            deleteable: true,
        };
        const updatedData = [...methods.getValues("brand_info_mob_app_public_menus_custom"), newRow];
        methods.setValue("brand_info_mob_app_public_menus_custom", updatedData);
        const api = table?.current?.getGridApi();
        if (api) {
            api.applyTransaction({ add: [newRow] });
        } else {
            console.error("Grid API not found!");
        }
    };
    const onRowDragEnd = (event) => {
        const updatedRowData = event.api.getDisplayedRowAtIndex(0).parent.childrenAfterSort
            .map(node => node.data);
        const preservedData = updatedRowData.map((row, index) => {
            return {
                feature: row.feature,
                alternativeMethod: row.alternativeMethod || '',
                enabled: row.enabled || false,
                deleteable: row.deleteable || false
            };
        });
        methods.setValue('brand_info_mob_app_public_menus_custom', preservedData);
        // methods.trigger(); 
        handleValueChanges();
    };
 
    // useEffect(() => {
    //     const backendData = methods.getValues('brand_info_mob_app_public_menus_custom');
      
    //     const finalRowData =
    //       backendData && Array.isArray(backendData) && backendData.length > 0
    //         ? backendData
    //         : (type === 'credit'
    //             ? formDataJson?.[2]?.["2_3"]?.brand_info_mob_app_public_menus_custom
    //             : formDataJson?.[3]?.["3_3"]?.brand_info_mob_app_public_menus_custom) || [];
      
    //     const shouldFallbackToDefault = finalRowData.length === 0;
    //     const actualRowData = shouldFallbackToDefault ? customMenus : finalRowData;
      
    //     setGridOptions({
    //       columnDefs: [
    //         { headerName: '', cellRenderer: IconRenderer },
    //         { headerName: 'Feature', field: 'feature', cellRenderer: CheckboxRenderer, editable: true, },
    //         { headerName: 'Alternative Name', field: 'alternativeMethod', cellRenderer: InputRenderer },
    //       ],
    //       rowSelection: 'single',
    //       rowData: actualRowData,
    //       rowDragEntireRow: true,
    //       rowDragManaged: true,
    //       onRowDragEnd: onRowDragEnd,
    //       context: { methods, handleValueChanges,handleGridApi },
    //     });
      
    //     const api = table?.current?.getGridApi();
    //     if (api && api.setRowData) {
    //       api.setRowData(actualRowData);
    //     }
    //   }, [isFormDataUpdated, formDataJson, methods.watch('brand_info_mob_app_public_menus_custom')]);
      useEffect(() => {
        // Get form state and fetched data
        const backendData = methods.getValues('brand_info_mob_app_public_menus_custom');
        const fetchedData =
          type === 'credit'
            ? formDataJson?.[2]?.["2_3"]?.brand_info_mob_app_public_menus_custom
            : formDataJson?.[3]?.["3_3"]?.brand_info_mob_app_public_menus_custom;
      
        // Determine row data: prioritize fetched data, then form state, then customMenus
        let finalRowData = [];
        if (Array.isArray(fetchedData) && fetchedData.length > 0) {
          finalRowData = fetchedData;
        } else if (Array.isArray(backendData) && backendData.length > 0) {
          finalRowData = backendData;
        } else {
          finalRowData = customMenus || [];
        }
      
        // Ensure form state is updated with the final row data
        methods.setValue('brand_info_mob_app_public_menus_custom', finalRowData, {
          shouldValidate: true,
          shouldDirty: false, // Prevent marking as dirty to avoid unintended submissions
        });
      
        // Set grid options
        setGridOptions({
          columnDefs: [
            { headerName: '', cellRenderer: IconRenderer },
            { headerName: 'Feature', field: 'feature', cellRenderer: CheckboxRenderer, editable: true },
            { headerName: 'Alternative Name', field: 'alternativeMethod', cellRenderer: InputRenderer },
          ],
          rowSelection: 'single',
          rowData: finalRowData,
          rowDragEntireRow: true,
          rowDragManaged: true,
          onRowDragEnd: onRowDragEnd,
          context: { methods, handleValueChanges, handleGridApi },
        });
      
        // Update grid API if available
        const api = table?.current?.getGridApi();
        if (api && api.setRowData) {
          api.setRowData(finalRowData);
        }
      }, [isFormDataUpdated]); 
    // Trigger validation when component mounts

    React.useEffect(() => {
        methods.trigger();
    }, []);
    const handleValueChanges = () => {
        const values = methods.getValues();
        const updatedSection = {
            ...(type === "credit"
                ? addFormData?.[2]?.["2_3"] ?? {}
                : addFormData?.[3]?.["3_3"] ?? {}),
            ...values,
        };
    
        setAddFormData((prev) => ({
            ...prev,
            [type === "credit" ? 2 : 3]: {
                ...prev[type === "credit" ? 2 : 3],
                [type === "credit" ? "2_3" : "3_3"]: updatedSection,
            },
        }));
    };
 
    useEffect(() => {
        customElements.whenDefined('i2c-file-upload').then(() => {
            Object.keys(fileRefs.current).forEach((fieldName) => {
                const fileRef = fileRefs.current[fieldName];
                if (fileRef.current !== null) {
                    const myDropzone = fileRef.current.getDropZone();
                    const token = localStorage.getItem("token");
                    myDropzone.options.url = process.env.REACT_APP_API_BASE_URL + "api/file/upload/pdf";
                    myDropzone.options.headers = {
                        'X-Requested-With': null,
                        'Access-Control-Allow-Headers': null,
                        'Authorization': 'Bearer ' + token,
                    };
                }
            });
        });
    }, []);
    // for PDF, svg, ai files
    const handleFileUpload = async (file, fieldName) => {
        const formData = new FormData();
        formData.append("file", file);
        try {
            await fileUpload.mutate({ formData, fieldName });
        } catch (error) {
            console.log(error);
        } finally {
            methods.trigger();
        }
    };

    const fileUpload = useMutation({
        mutationFn: async ({ formData, fieldName }) => {

            setFormValidStates(state, false);
            return await FilesUploadService.uploadFile(formData);
        },
        onSuccess: (data, { fieldName }) => {
            if (fieldName === "brand_info_mob_app_android_module_features_file" || fieldName === "brand_info_mob_app_ios_module_features_file") {
                const currentFiles = methods.getValues(fieldName) || [];
                methods.setValue(fieldName, [...currentFiles, data?.data?.url]);
            }
            else {
                methods.setValue(fieldName, data?.data?.url);
            }

            methods.trigger();
            handleValueChanges();
        },
        onError: (e) => {
            console.log("API error", e);
        },
    });

    console.log("error in mobile", errors);
    // Update form validation state when errors change
    React.useEffect(() => {
        const errorsLength = Object.keys(errors)?.length;
        if (type === "credit") {
            if (errorsLength === 0) setFormValidStates("2_3", true);
            else setFormValidStates("2_3", false);
        }
        else {
            if (errorsLength === 0) setFormValidStates("3_3", true);
            else setFormValidStates("3_3", false);
        }
    }, [Object.keys(errors)?.length]);

    return (
        <React.Fragment>
            <div className="forms-instance">
                <div className="custom-label-light">
                    This section must be filled if you have indicated above that you want to offer i2c C-Holder Web to your cardholders.
                </div>
                <div className="sticky-position-nav">
                    <div className='web-app-public-nav-wrapper'>
                        {navigationMob.map((nv, idx) => <I2cButton onClick={() => handleNav(idx)} key={idx} variant={`${nav === idx ? "secondary color" : "tertiary gray"}`} size='small'>{nv}</I2cButton>)}
                    </div>
                </div>
                <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[0] = el}>
                    <div i2c-grid="12 6@md" >
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    App Icon
                                    <I2cTooltip
                                        content="The content of all public pages, including the ones that have their links in the Header section, will be required in the “Branding Specifications Common to Both Mobile and Web Apps” section below. "
                                        placement="right-start"
                                    >
                                        <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                    </I2cTooltip>
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <Controller
                            name="brand_info_mob_app_icon_file"
                            control={control}
                            render={({ field }) => (
                                <I2cFileUpload
                                    ref={getFileRef("brand_info_mob_app_icon_file")}
                                    max-file-size="0.9814697265625"
                                    autoProcessQueue={false}
                                    no-mobile-controls
                                    max-files={1}
                                    className="customFileUpload"
                                    setAcceptedFiles=".svg, .ai"
                                    icon="linear-document-upload"
                                    label="Click to upload"
                                    caption="or drag and drop"
                                    name="brand_info_mob_app_icon_file"
                                    message="Format: SVG or AI"
                                    onI2cFileRemoved={(e) => {
                                        if (
                                            fileJson?.brand_info_mob_app_icon_file?.length
                                        )
                                            methods.setValue(
                                                "brand_info_mob_app_icon_file",
                                                fileJson?.brand_info_mob_app_icon_file,
                                            );
                                        else methods.setValue("brand_info_mob_app_icon_file", "");
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                    onI2cAddedFile={(e) => {
                                        const fileRef = getFileRef("brand_info_mob_app_icon_file");
                                        handleFileUpload(
                                            fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                            "brand_info_mob_app_icon_file"
                                        );
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>
                <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[1] = el}>
                    <div i2c-grid="12 6@md">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Splash Screen
                                    <I2cTooltip
                                        content="The content of all public pages, including the ones that have their links in the Header section, will be required in the “Branding Specifications Common to Both Mobile and Web Apps” section below. "
                                        placement="right-start"
                                    >
                                        <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                    </I2cTooltip>
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="custom-label mb-1-5">
                            Please provide the collateral for the Splash Screen.
                        </div>
                        <Controller
                            name="brand_info_mob_app_splash_screen_file"
                            control={control}
                            render={({ field }) => (
                                <I2cFileUpload
                                    ref={getFileRef("brand_info_mob_app_splash_screen_file")}
                                    max-file-size="0.9814697265625"
                                    autoProcessQueue={false}
                                    no-mobile-controls
                                    max-files={1}
                                    className="customFileUpload"
                                    setAcceptedFiles=".svg, .ai"
                                    icon="linear-document-upload"
                                    label="Click to upload"
                                    caption="or drag and drop"
                                    name="brand_info_mob_app_splash_screen_file"
                                    message="Format: SVG or AI"
                                    onI2cFileRemoved={(e) => {
                                        if (
                                            fileJson?.brand_info_mob_app_splash_screen_file?.length
                                        )
                                            methods.setValue(
                                                "brand_info_mob_app_splash_screen_file",
                                                fileJson?.brand_info_mob_app_splash_screen_file,
                                            );
                                        else methods.setValue("brand_info_mob_app_splash_screen_file", "");
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                    onI2cAddedFile={(e) => {
                                        const fileRef = getFileRef("brand_info_mob_app_splash_screen_file");
                                        handleFileUpload(
                                            fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                            "brand_info_mob_app_splash_screen_file"
                                        );
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>
                <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[2] = el}>
                    <div i2c-grid="12 6@md">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Introduction Screens
                                    <I2cTooltip
                                        content="The content of all public pages, including the ones that have their links in the Header section, will be required in the “Branding Specifications Common to Both Mobile and Web Apps” section below. "
                                        placement="right-start"
                                    >
                                        <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                    </I2cTooltip>
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="custom-label mb-1-5">
                            Card Design
                        </div>
                        <Controller
                            name="brand_info_mob_app_card_design_file"
                            control={control}
                            render={({ field }) => (
                                <I2cFileUpload
                                    ref={getFileRef("brand_info_mob_app_card_design_file")}
                                    max-file-size="0.939453125"
                                    autoProcessQueue={false}
                                    no-mobile-controls
                                    max-files={1}
                                    className="customFileUpload"
                                    setAcceptedFiles=".svg, .ai"
                                    icon="linear-document-upload"
                                    label="Click to upload"
                                    caption="or drag and drop"
                                    name="brand_info_mob_app_card_design_file"
                                    message="Format: SVG or AI"
                                    onI2cFileRemoved={(e) => {
                                        if (
                                            fileJson?.brand_info_mob_app_card_design_file?.length
                                        )
                                            methods.setValue(
                                                "brand_info_mob_app_card_design_file",
                                                fileJson?.brand_info_mob_app_card_design_file,
                                            );
                                        else methods.setValue("brand_info_mob_app_card_design_file", "");
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                    onI2cAddedFile={(e) => {
                                        const fileRef = getFileRef("brand_info_mob_app_card_design_file");
                                        handleFileUpload(
                                            fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                            "brand_info_mob_app_card_design_file"
                                        );
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_mob_app_textual_content"
                                control={control}
                                render={({ field }) => (
                                    <I2cTextarea
                                        label="Textual Content"
                                        {...field}
                                        name="brand_info_mob_app_textual_content"
                                        resize="none"
                                        onI2cInput={(e) => {
                                            const value = e.target.value;
                                            field.onChange(value);
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                        placeholder="Enter textual content"
                                        rows={5}
                                    />
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_mob_app_textual_content &&
                                        methods.formState.touchedFields.brand_info_mob_app_textual_content
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_mob_app_textual_content?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="custom-label mb-1-5">
                            Art Background Image
                        </div>
                        <Controller
                            name="brand_info_mob_app_art_background_image_file"
                            control={control}
                            render={({ field }) => (
                                <I2cFileUpload
                                    ref={getFileRef("brand_info_mob_app_art_background_image_file")}
                                    max-file-size="0.439453125"
                                    autoProcessQueue={false}
                                    no-mobile-controls
                                    max-files={1}
                                    className="customFileUpload"
                                    setAcceptedFiles=".svg, .ai"
                                    icon="linear-document-upload"
                                    label="Click to upload"
                                    caption="or drag and drop"
                                    name="brand_info_mob_app_art_background_image_file"
                                    message="Format: SVG or AI"
                                    onI2cFileRemoved={(e) => {
                                        if (
                                            fileJson?.brand_info_mob_app_art_background_image_file?.length
                                        )
                                            methods.setValue(
                                                "brand_info_mob_app_art_background_image_file",
                                                fileJson?.brand_info_mob_app_art_background_image_file,
                                            );
                                        else methods.setValue("brand_info_mob_app_art_background_image_file", "");
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                    onI2cAddedFile={(e) => {
                                        const fileRef = getFileRef("brand_info_mob_app_art_background_image_file");
                                        handleFileUpload(
                                            fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                            "brand_info_mob_app_art_background_image_file"
                                        );
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="custom-label mb-1-5">
                            Additional Textual Content
                        </div>
                        <Controller
                            name="brand_info_mob_app_additional_textual_content_file"
                            control={control}
                            render={({ field }) => (
                                <I2cFileUpload
                                    ref={getFileRef("brand_info_mob_app_additional_textual_content_file")}
                                    max-file-size="0.439453125"
                                    autoProcessQueue={false}
                                    no-mobile-controls
                                    max-files={1}
                                    className="customFileUpload"
                                    setAcceptedFiles=".pdf, .esp"
                                    icon="linear-document-upload"
                                    label="Click to upload"
                                    caption="or drag and drop"
                                    name="brand_info_mob_app_additional_textual_content_file"
                                    message="Format: PDF or ESP"
                                    onI2cFileRemoved={(e) => {
                                        if (
                                            fileJson?.brand_info_mob_app_additional_textual_content_file?.length
                                        )
                                            methods.setValue(
                                                "brand_info_mob_app_additional_textual_content_file",
                                                fileJson?.brand_info_mob_app_additional_textual_content_file,
                                            );
                                        else methods.setValue("brand_info_mob_app_additional_textual_content_file", "");
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                    onI2cAddedFile={(e) => {
                                        const fileRef = getFileRef("brand_info_mob_app_additional_textual_content_file");
                                        handleFileUpload(
                                            fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                            "brand_info_mob_app_additional_textual_content_file"
                                        );
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_mob_app_sign_up_option"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        label="Do you want to provide the “Sign Up” option on this screen?"
                                        {...field}
                                        name="brand_info_mob_app_sign_up_option"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {["Yes", "No"].map((so, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_mob_app_sign_up_option") === so
                                                }
                                                value={so}
                                            >
                                                {so}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_mob_app_sign_up_option &&
                                        methods.formState.touchedFields.brand_info_mob_app_sign_up_option
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_mob_app_sign_up_option?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12 8@md">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span>
                                    Navigation Bar Color Scheme
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                        <div className="custom-label">
                            You can choose i2c’s default color scheme or opt for customized color scheme.
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <div className="custom-label mb-8 productIconFlex">
                                Please specify the brand colors you want to use
                                <span>
                                    <I2cTooltip content="If you wish to customize the navigation bar color scheme, please provide the RGB or hexadecimal color code for the navigation bar. 
                                        This will be a common color code throughout the app."
                                        placement="right-start">
                                        <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                    </I2cTooltip>
                                </span>
                            </div>
                            <Controller
                                name="brand_info_mob_app_nav_color_scheme"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        label=""
                                        {...field}
                                        name="brand_info_mob_app_nav_color_scheme"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            if(e.target.value !== "Custom color scheme"){
                                                methods.setValue("brand_info_mob_app_nav_color_scheme_field" , "");
                                                setColorNav("#ffffff");
                                            }
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {["Default color scheme", "Custom color scheme"].map((cs, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_mob_app_nav_color_scheme") === cs
                                                }
                                                value={cs}
                                            >
                                                {cs}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_mob_app_nav_color_scheme &&
                                        methods.formState.touchedFields.brand_info_mob_app_nav_color_scheme
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_mob_app_nav_color_scheme?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {methods.watch("brand_info_mob_app_nav_color_scheme") === "Custom color scheme" && (
                        <div i2c-grid="12 6@md">
                            <>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_mob_app_nav_color_scheme_field"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cColorPicker layout="custom" label="Primary"
                                                {...field}
                                                className="single-input-field"
                                                required
                                                onI2cChange={(e) => {
                                                    const value = e.target.value || e.target.getFormattedValue();
                                                    field.onChange(value);
                                                    setColorNav(value);
                                                    handleValueChanges();
                                                }}
                                                placement="top"
                                                size="large"
                                                name={"brand_info_mob_app_nav_color_scheme_field"}
                                            >
                                                <I2cInput
                                                    readonly label="Custom Color Scheme" value={colorNav} name={"brand_info_mob_app_nav_color_scheme_field"} slot="trigger" style={{ '--custom-preview': colorNav }}>
                                                    <I2cIcon style={{ '--featured-color': colorNav }} slot="prefix" name="cs-bold-indicator"></I2cIcon>
                                                </I2cInput>
                                            </I2cColorPicker>
                                        )}
                                    />
                                </div>
                            </>
                        </div>
                    )}
                </div>
                <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[3] = el}>
                    <div i2c-grid="12 8@md">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span >
                                    Login Screen
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                        <div className="custom-label">
                            Please provide your branding logo and the color scheme for the Log-In screen.
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="custom-label mb-1-5">
                            Logo
                        </div>
                        <Controller
                            name="brand_info_mob_app_nav_color_scheme_logo"
                            control={control}
                            render={({ field }) => (
                                <I2cFileUpload
                                    ref={getFileRef("brand_info_mob_app_nav_color_scheme_logo")}
                                    max-file-size="0.17166137695312"
                                    autoProcessQueue={false}
                                    no-mobile-controls
                                    max-files={1}
                                    className="customFileUpload"
                                    setAcceptedFiles=".pdf, .esp"
                                    icon="linear-document-upload"
                                    label="Click to upload"
                                    caption="or drag and drop"
                                    name="brand_info_mob_app_nav_color_scheme_logo"
                                    message="High Resolution Image (1200x1200px) or Source file in SVG, AI Format"
                                    onI2cFileRemoved={(e) => {
                                        if (
                                            fileJson?.brand_info_mob_app_nav_color_scheme_logo?.length
                                        )
                                            methods.setValue(
                                                "brand_info_mob_app_nav_color_scheme_logo",
                                                fileJson?.brand_info_mob_app_nav_color_scheme_logo,
                                            );
                                        else methods.setValue("brand_info_mob_app_nav_color_scheme_logo", "");
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                    onI2cAddedFile={(e) => {
                                        const fileRef = getFileRef("brand_info_mob_app_nav_color_scheme_logo");
                                        handleFileUpload(
                                            fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                            "brand_info_mob_app_nav_color_scheme_logo"
                                        );
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div i2c-grid="12 6@md">
                        <div className="custom-label mb-16">
                            Color Scheme
                        </div>
                        <div className="single-field-wrapper">
                            {fieldColor.map((field, index) => (
                                <div key={field.id} className="color-array-fields">
                                    <Controller
                                        name={`brand_info_mob_app_login_color_scheme_code[${index}]`}
                                        control={control}
                                        render={({ field }) => (
                                            <I2cColorPicker layout="custom" label="Primary"
                                                {...field}
                                                className="single-input-field"
                                                required
                                                onI2cChange={(e) => {
                                                    const value = e.target.value || e.target.getFormattedValue();
                                                    field.onChange(value);
                                                    handleColorChange(index, value);
                                                    handleValueChanges();
                                                }}
                                                placement="top"
                                                size="large"
                                                name={`brand_info_mob_app_login_color_scheme_code[${index}]`}
                                            >
                                                <I2cInput
                                                    readonly

                                                    value={colorValues[index] || ""}
                                                    name={`brand_info_mob_app_login_color_scheme_code[${index}]`}
                                                    slot="trigger"
                                                    style={{ '--custom-preview': colorValues[index] || "#ffffff" }}
                                                >
                                                    <I2cIcon
                                                        style={{ '--featured-color': colorValues[index] || "#ffffff" }}
                                                        slot="prefix"
                                                        name="cs-bold-indicator"
                                                    />
                                                </I2cInput>
                                            </I2cColorPicker>
                                        )}
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="single-field-wrapper">
                            <I2cButton variant="link color" onClick={addColorField}>
                                <I2cIcon slot="prefix" name="linear-add"></I2cIcon> Add Color
                            </I2cButton>
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="custom-label mb-1-5">
                            Background Image
                        </div>
                        <Controller
                            name="brand_info_mob_app_login_background_file"
                            control={control}
                            render={({ field }) => (
                                <I2cFileUpload
                                    ref={getFileRef("brand_info_mob_app_login_background_file")}
                                    max-file-size="0.17166137695312"
                                    autoProcessQueue={false}
                                    no-mobile-controls
                                    max-files={1}
                                    className="customFileUpload"
                                    setAcceptedFiles=".pdf, .esp"
                                    icon="linear-document-upload"
                                    label="Click to upload"
                                    caption="or drag and drop"
                                    name="brand_info_mob_app_login_background_file"
                                    message="High Resolution Image (1200x1200px) or Source file in SVG, AI Format"
                                    onI2cFileRemoved={(e) => {
                                        if (
                                            fileJson?.brand_info_mob_app_login_background_file?.length
                                        )
                                            methods.setValue(
                                                "brand_info_mob_app_login_background_file",
                                                fileJson?.brand_info_mob_app_login_background_file,
                                            );
                                        else methods.setValue("brand_info_mob_app_login_background_file", "");
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                    onI2cAddedFile={(e) => {
                                        const fileRef = getFileRef("brand_info_mob_app_login_background_file");
                                        handleFileUpload(
                                            fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                            "brand_info_mob_app_login_background_file"
                                        );
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>
                <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[4] = el}>
                    <div i2c-grid="12 8@md">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span>
                                    Public Menus & Icons
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                        <div className="custom-label">
                            Public menus allow cardholders to view pages or information without having to log into the app.
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_mob_app_public_menus_icons_type"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        label="Do you want to use i2c default public menus and icons, or customize them"
                                        {...field}
                                        name="brand_info_mob_app_public_menus_icons_type"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            methods.trigger();
                                            handleValueChanges();
                                            setIsFormDataUpdated(prev => !prev);
                                        }}
                                    >
                                        {["Default Menus & Icons", "Custom Menus & Icons"].map((mit, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_mob_app_public_menus_icons_type") === mit
                                                }
                                                value={mit}
                                            >
                                                {mit}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_mob_app_public_menus_icons_type &&
                                        methods.formState.touchedFields.brand_info_mob_app_public_menus_icons_type
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_mob_app_public_menus_icons_type?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {methods.watch("brand_info_mob_app_public_menus_icons_type") === "Custom Menus & Icons" && (
                        <>
                            <div i2c-grid="12 12@md">
                                <div className="custom-label mb-1-5">
                                    Please upload the file containing custom names and icons.
                                </div>

                                <Controller
                                    name="brand_info_mob_app_public_menus_custom"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cDataTable
                                            id="dataTable1"
                                            ref={table}
                                            gridOptionInput={gridOptions}
                                            notFound={[
                                                {
                                                    description:
                                                        'No data available. Please add some features or refresh the page.',
                                                    type: 'noData',
                                                    icon: 'outline-info-circle',
                                                    primaryBtn: `<i2c-button variant="primary" size='large'>Reload</i2c-button>`,
                                                },
                                            ]}
                                        ></I2cDataTable>
                                    )}
                                />
                            </div>
                            <div i2c-grid="12">
                                <I2cButton variant="link color"
                                    onClick={() => addNewRow(table)}>
                                    <I2cIcon slot="prefix" name="linear-add"></I2cIcon> Add
                                </I2cButton>
                            </div>
                        </>
                    )}
                </div>

                {iosApp && !androidApp && (
                    <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[5] = el}>
                        <IOSApplicationGuidelines
                            control={control}
                            handleValueChanges={handleValueChanges}
                            methods={methods}
                            errors={errors}
                            getFileRef={getFileRef}
                            handleFileUpload={handleFileUpload}
                            fileJson={fileJson}
                        />
                    </div>
                )}
                {androidApp && !iosApp && (
                    <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[5] = el}>
                        <AndroidGuidelines
                            control={control}
                            handleValueChanges={handleValueChanges}
                            methods={methods}
                            errors={errors}
                            getFileRef={getFileRef}
                            handleFileUpload={handleFileUpload}
                            fileJson={fileJson}
                        />
                    </div>
                )}
                {bothApps && (
                    <>
                        <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[5] = el}>
                            <IOSApplicationGuidelines
                                control={control}
                                handleValueChanges={handleValueChanges}
                                methods={methods}
                                errors={errors}
                                getFileRef={getFileRef}
                                handleFileUpload={handleFileUpload}
                                fileJson={fileJson}
                            />
                        </div>
                        <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[6] = el}>
                            <AndroidGuidelines
                                control={control}
                                handleValueChanges={handleValueChanges}
                                methods={methods}
                                errors={errors}
                                getFileRef={getFileRef}
                                handleFileUpload={handleFileUpload}
                                fileJson={fileJson}
                            />
                        </div>
                    </>
                )}

            </div>
        </React.Fragment>
    )
}
export default MobileAppGraphicsSpecifications;